<sm-container-list-item
  [container]="container"
  [searchQuery]="searchQuery"
  [inventoryMenu]="inventoryMenu"
  [menuItems]="menuItems"
  [emptyDescriptionLabel]="emptyDescriptionLabel"
  [menuAriaLabel]="menuAriaLabel"
  (open)="handleOpen()"
  (menuItemSelect)="handleMenuItemSelect($event)">
</sm-container-list-item>
